import React, {useState} from "react";
import PropTypes from "prop-types";
import ModalBox from "components/Alert/Modal.js";
import Spinner from "components/Alert/Spinner";
import Paypal from "components/Common/Paypal";
import useAuth from "components/Common/UseAuth";

// components
export default function CardCredits({ color, credits }) {

  let [loading, setLoading] = useState(false);
  const {checkSession,user}=useAuth();

  const [modalDetail, setModalDetail] = useState("");  
  const showModal = (title,desc) => {
    setModalDetail(<ModalBox title={title} desc={desc} show="true" callback={()=>{
        setModalDetail(<div></div>);
        setLoading(false);
    }}/>);
  }

  const PaymentSuccess = () => {    
    setLoading(false);
    checkSession();
    showModal("MBLink Payment Method",
        <>     
          <span>Thank you for purchasing...</span>   
        </>  
    );
  }

  const PaymentError = (err) => {
    setLoading(false);
    showModal("MBLink Payment Method",
        <>     
          <span>Payment could not be received. Please try again!</span>   
        </>  
    );
  }

  const PaymentStart = () => {
    setLoading(true);
  }  

  const doPayment = (price,sku) => {
    showModal("MBLink Payment Method",
        <>     
          <Paypal sku={sku} onSuccess={PaymentSuccess} onError={PaymentError} onStartTransaction={PaymentStart}></Paypal>   
        </>  
    );
  }

  const getPrice = (sku) => {
    let price = 0;
    user.availabletokens.forEach(skutypes => {
        if (skutypes.sku===sku) {  
          price=skutypes.price;
          return;          
        }
    });
    return price;
  }


  return (
    <>
      {loading?<Spinner show={loading} />:null}
      {modalDetail!==""?modalDetail:null}

      <div
        className={
          "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
          (color === "light" ? "bg-white" : "bg-blue-900 text-white")
        }
      >
        <div className="rounded-t mb-0 px-4 py-3 border-0">
          <div className="flex flex-wrap items-center">
            <div className="relative w-full px-4 max-w-full flex-grow flex-1">
              <h3
                className={
                  "font-semibold text-lg " +
                  (color === "light" ? "text-gray-800" : "text-white")
                }
              >
                Credits Table
              </h3>
            </div>
          </div>
        </div>
        <div className="block w-full overflow-x-auto">
          {/* Projects table */}
          <table className="items-center w-full bg-transparent border-collapse">
            <thead>
              <tr>
                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-no-wrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-gray-100 text-gray-600 border-gray-200"
                      : "bg-blue-800 text-blue-300 border-blue-700")
                  }
                >
                  Process Name
                </th>                
                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-no-wrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-gray-100 text-gray-600 border-gray-200"
                      : "bg-blue-800 text-blue-300 border-blue-700")
                  }
                >
                  Description
                </th>                
                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-no-wrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-gray-100 text-gray-600 border-gray-200"
                      : "bg-blue-800 text-blue-300 border-blue-700")
                  }
                >
                  Amount
                </th>
                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-no-wrap font-semibold text-center " +
                    (color === "light"
                      ? "bg-gray-100 text-gray-600 border-gray-200"
                      : "bg-blue-800 text-blue-300 border-blue-700")
                  }
                >
                  Price
                </th>
              </tr>
            </thead>
            <tbody>
            {credits!=null && credits.map((item,index) => {
                return (
                  <tr key={index} className={((index%2) === 0
                    ? "bg-blue-100 text-white-300 border-blue-200"
                    : "bg-blue-800 text-white-300 border-blue-700")}>
                    <th className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4 text-left flex items-center">
                      <span className="fa fa-user-cog text-2xl"></span>
                      <span
                        className={
                          "ml-3 font-bold " +
                          +(color === "light" ? "text-gray-700" : "text-white")
                        }
                      >
                        {item.caption}
                      </span>
                    </th>
                    <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs p-4">
                      {item.desc}
                    </td>
                    <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4">
                      {item.amount} Credits
                    </td>
                    <td className="border-t-0 px-6 align-middle text-center border-l-0 border-r-0 text-xs whitespace-no-wrap p-4">
                        <button className="mx-auto text-white-500 border border-solid border-blue-500 hover:bg-blue-500 hover:text-white active:bg-blue-600 font-bold uppercase text-sm px-3 py-3 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" 
                          type="button"
                          onClick={(e)=>doPayment(getPrice(item.sku),item.sku)}
                          >
                            BUY {getPrice(item.sku)} EUR 
                        </button>                      
                    </td>                    
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

CardCredits.defaultProps = {
  color: "light",
};

CardCredits.propTypes = {
  color: PropTypes.oneOf(["light", "dark"]),
};
